<template>
	<div class="home-screen flex column flex-center justify-between text-noir">
		<div class="col-width text-center home-main">

			<h1 class="title q-pb-lg">
				<em>
					Déforestation&nbsp;:
				</em>
				<em>
					la France complice
				</em>
			</h1>

			<p>
				En Amérique du Sud, l’Amazonie et d’autres écosystèmes précieux sont détruits sous nos yeux. Le mobile&nbsp;? L’appât du gain. Les coupables sont bien connus&nbsp;: les agro-industriels dévastent chaque année des millions d’hectares pour élever du bétail mais aussi cultiver du soja quasi-systématiquement OGM et bourré de pesticides. Sale histoire. Alors que le Président Macron a reconnu la "part de complicité" de la France dans cette affaire, une nouvelle preuve de notre implication apparaît sous nos yeux.
			</p>

			<p>
				Jeudi 19 septembre, un cargo en provenance du Brésil arrive dans un port près de Saint-Nazaire pour y décharger 60&nbsp;000 tonnes de soja issu d'une zone où sa culture fait des ravages&nbsp;: le Cerrado. Ce soja détruit des trésors de biodiversité pour alimenter nos fermes-usines qui polluent notre planète et menacent notre santé. <b>Ce système infernal doit prendre fin</b>. 
			</p>

			<p>
				Tant que le gouvernement restera les bras croisés face à cette catastrophe environnementale, nous poursuivrons notre mobilisation pour que ce système infernal cesse. <b>Agissez avec nous</b>.
			</p>


			<p class="q-mt-lg q-pt-lg">
				<q-btn class="btn-main" label="Je dénonce l'arrivée de ce cargo" @click="$emit('click')"/>
			</p>
		</div>

		<slot name="default"/>

	</div>
</template>

<script>
export default {
	name: 'HomeScreen',
	props: {
		concerned: String,
	}
}
</script>

<style lang="stylus" scoped>
@import '~quasar-variables'

.home-screen
	padding-top 2rem
	flex-grow 99
	background-color #fff
	background-image url(/preuve-deforestation/fond.jpg)
	background-size cover
	min-height 100vh

.home-main
	padding 3rem 1rem 4rem



</style>